export function BoxSVG(props: React.ComponentProps<'svg'>) {
  return (
    <svg height={30} viewBox="0 0 34 30" width={34} xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
      <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={1.2}>
        <path d="M32.904 10.97H1" strokeLinecap="round" />
        <path d="M32.904 10.97L25.39 1H8.503L1 10.97v17.946h31.904zM16.952 1v10.125" />
      </g>
    </svg>
  );
}
